import { Button } from "@mui/material";
import React from "react";
import DepositIcon from "../icons/DepositIcon";
import WithdrawIcon from "../icons/WithdrawIcon";

export default function WalletTag({ type = "deposit", ...restProps }) {
  return (
    <Button
      {...restProps}
      variant="contained"
      sx={{
        backgroundColor: type === "deposit" ? "#542CE8" : "#B83131",
        borderRadius: "4px",
        textTransform: "none",
      }}
      startIcon={type === "deposit" ? <DepositIcon /> : <WithdrawIcon />}
    >
      {type === "deposit" ? "Deposit" : "Withdraw"}
    </Button>
  );
}
